import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PlainDateTimePipe } from '@common/pipes/plain-date.pipe';
import { SystemConsistencyFindingDTO } from '@gen/systemConsistencyFinding/systemConsistencyFinding.dto';
import { EntityType } from '@gen-common/enums';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { firstValueFrom } from 'rxjs';

import { Filter } from '@/shared/filter';
import { PlainDateTime } from '@/shared/plain-date-util';

type SystemConsistencyRunResult = {
  checkedAt: PlainDateTime;
  findingsCount: number;
};

@Component({
  selector: 'app-system-consistency',
  templateUrl: './system-consistency.component.html',
  standalone: true,
  imports: [CommonModule, RouterLink, ButtonModule, TableModule, PlainDateTimePipe],
  providers: []
})
export class SystemConsistencyComponent implements OnInit {
  private readonly http = inject(HttpClient);

  findings: SystemConsistencyFindingDTO[] = [];
  loading = false;
  running = false;
  lastRun?: SystemConsistencyRunResult;

  async ngOnInit(): Promise<void> {
    await this.loadFindings();
  }

  async runChecks(): Promise<void> {
    this.running = true;
    try {
      this.lastRun = await firstValueFrom(this.http.get<SystemConsistencyRunResult>('/api/ext-system-consistency/run'));
      await this.loadFindings();
    } finally {
      this.running = false;
    }
  }

  async loadFindings(): Promise<void> {
    this.loading = true;
    try {
      const filter = new Filter<SystemConsistencyFindingDTO>();
      this.findings = await firstValueFrom(this.http.post<SystemConsistencyFindingDTO[]>('/api/systemConsistencyFinding/list', filter));
    } finally {
      this.loading = false;
    }
  }

  entityLink(finding: SystemConsistencyFindingDTO): Array<string | number> | null {
    if (finding.entity_type === EntityType.RESERVATION) {
      return ['/reservation', finding.entity_id];
    }
    if (finding.entity_type === EntityType.FACTURA) {
      return ['/factura', finding.entity_id];
    }
    return null;
  }
}
